import { NetworkData, NetworkStatus } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export const NetworkStatusDic = {
    [NetworkStatus.Active]: 'Active',
    [NetworkStatus.Archived]: 'Archive',
};

interface FilterParams {
    ids?: string[];
}

export class NetworkList extends SimpleList<NetworkData, FilterParams> {
    public static Name = 'networkList' as const;

    protected filterValue(value: NetworkData, { ids }: FilterParams): boolean {
        return ids ? ids.includes(value.id) : true;
    }
}

export const networkList = new NetworkList();
